import React, { useEffect } from 'react';
import { Card, PageWrapper } from 'mui';
import ReferralLink from 'app/components/common/ReferralLink';
import { useAppSelector } from 'app/helpers/hooks';
import { selectCustomer } from 'app/selectors/customer';
import cx from 'classnames';
import { dateFormatter } from 'app/helpers/formatters';
import GiftImage from 'images/gift.svg';
import PeopleImage from 'images/people.svg';
import { trackEvent } from 'app/utils/useCommonTracking';

const TrackReferrals = () => {
  const customer = useAppSelector(selectCustomer);
  const referralCode = customer.get('referral_code');
  const creditAmount = customer.get('credit_amount');
  const creditTotalEarned = customer.get('credit_total_earned');
  const creditTransactionsHistory = customer.get('credit_transactions_history');

  useEffect(() => {
    trackEvent('Viewed Referral Tracking Page');
  }, []);

  return (
    <PageWrapper wrapperClassName="flex flex-col gap-y-6 lg:gap-y-8">
      <div className="ml-10 sm:ml-5">
        <h3>Give $50, get $50</h3>
        <p>
          When you refer a friend, they’ll receive $50 off their first new plan, and you’ll receive a $50 credit applied
          to your next bill.
        </p>
      </div>
      <Card>
        <Card.Body>
          <div className="flex flex-row justify-between">
            <div>
              <p>Credit on Next Bill</p>
              <h4 className={cx({ 'text-[#0C144280]': creditAmount === 0, 'text-[#349C00]': creditAmount > 0 })}>
                ${(creditAmount / 100).toFixed(2)}
              </h4>
            </div>
            <div>
              <p>All-Time Earned</p>
              <h4>${(creditTotalEarned / 100).toFixed(2)}</h4>
            </div>
          </div>
          <ReferralLink referralCode={referralCode} />
        </Card.Body>
      </Card>
      {creditTransactionsHistory.size > 0 && (
        <>
          <div className="ml-10 sm:ml-5">
            <p className="heading-label">History</p>
          </div>
          <Card>
            <Card.Body>
              {creditTransactionsHistory.map((item, i) => {
                const amount = item.get('amount_cents');
                const created_at = item.get('created_at');
                const icon = amount > 0 ? GiftImage : PeopleImage;

                return (
                  <>
                    <div key={created_at} className="flex flex-row justify-between">
                      <div>
                        <p>{item.get('name')}</p>
                        <p className="text-xs text-[#0C144280]">
                          <img src={icon} className="h-[12px] -mt-1 inline" /> {dateFormatter(created_at)}
                        </p>
                      </div>
                      <div>
                        <h5 className={item.get('amount_cents') > 0 ? 'text-[#0C144280]' : 'text-[#FF542E]'}>
                          {amount > 0 ? '+' : '-'} ${(Math.abs(amount) / 100).toFixed(2)}
                        </h5>
                      </div>
                    </div>
                    {i < creditTransactionsHistory.size - 1 && <hr />}
                  </>
                );
              })}
            </Card.Body>
          </Card>
        </>
      )}
    </PageWrapper>
  );
};

export default TrackReferrals;
